/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-04-28 14:11:02
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-30 11:17:02
 */
import MeshManage from '../../meshManage';
import SkirtingBoard from '../../specialHandler/skirtingBoard';
import TopPanel from '../../specialHandler/topPanel';
import { AXES_ENUM, BASICTYPE_ENUM, LengthLocation, LengthType, } from '../../utils/enum';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG, TOPPANELCONFIG } from '../../utils/kitchenConfig';
import { checkHasHightFrameByPosition } from '../../utils/renderUtils';
import { getFramePositionInfo } from '../../utils/templatejsonUtils';
import { getLengthXTopPanelInfo, getLengthZTopPanelInfo } from '../../heightSinkCabinet/renderLSinkCabinet';
// 渲染L1的台面
function renderL1TopPanelUtil(topPanelTexture, renderLThis) {
    var _a, _b, _c;
    // L1边
    const lastFrame = (_a = renderLThis.templateJson.bottom.length1) === null || _a === void 0 ? void 0 : _a.frames[renderLThis.templateJson.bottom.length1.frames.length - 1];
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const l1SidePlateDepth = renderLThis.getSidePlateDepth('length1');
    // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
    let sealPlateSizeX = 0;
    // modify add by zhanyu.shen 20211227, 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如底柜240顶柜307)
    if (renderLThis.isSealPlateBeforeTopHightFrame(LengthType.Length1)
        || renderLThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
        sealPlateSizeX = renderLThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    }
    else {
        sealPlateSizeX = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    }
    // add by zhanyu.shen 20211221 end
    const mesh = renderLThis.scene.getMeshByName(lastFrame.componentBasic.id);
    if (!mesh) {
        return;
    }
    const lastMeshManage = new MeshManage(mesh);
    const lengthXConfigs = lastMeshManage.getLengthXConfigs(sealPlateSizeX + l1SidePlateDepth);
    const l1TopPanelArr = [];
    const l1TopPanelInfoArr = getLengthXTopPanelInfo(renderLThis, lengthXConfigs);
    l1TopPanelInfoArr.forEach((item) => {
        const tempTopPanel = new TopPanel(renderLThis.scene, item.position, item.size, true);
        tempTopPanel.createTopPanel(topPanelTexture);
        l1TopPanelArr.push(tempTopPanel);
    });
    const l1LastTopPanel = l1TopPanelArr[l1TopPanelArr.length - 1];
    // 判断水槽的位置及所在边   version2.0
    const sinkPositionInfo = Object.assign({}, getFramePositionInfo(renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson, 'sink'));
    if (sinkPositionInfo.id && sinkPositionInfo.location === 1) {
        // const tempLengthClass = new LengthX(renderLThis.templateJson, renderLThis.scene);
        // eslint-disable-next-line max-len
        const { holePosition, holeSize } = renderLThis.bottomLength1.getSinkHolePosition(sinkPositionInfo.cabinetId, sinkPositionInfo.id, l1LastTopPanel.position.y, sinkPositionInfo.cornerCabinetDirection, sinkPositionInfo.frameInfo);
        renderLThis.bottomLength1.createHole(holePosition, holeSize, topPanelTexture, l1LastTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
    }
    // 如果有高柜，高柜位置挖洞
    if (renderLThis.highFrameMesh && renderLThis.highFrameMeshLocation === 1) {
        // version 2.0 modify by zhanyu.shen 20220104 begin 将多个高柜作为一个整体获取中心坐标和尺寸
        // const highFrameMeshBounds = renderLThis.highFrameMesh.getHierarchyBoundingVectors();
        // 2.3高柜新增一块侧板 台面挖洞需要相应调整
        // 侧板内侧的侧板厚度 2.3版本前无内侧侧板
        const highFrameFirstSidePlateHoleDepth = renderLThis.templateJson.version > '2.2' ? l1SidePlateDepth : 0;
        const highFrameData = renderLThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.bottom, LengthType.Length1); // new code
        const holePosition = {
            // x: highFrameMeshBounds.min.x + (highFrameMeshBounds.max.x - highFrameMeshBounds.min.x) / 2
            // - TOPPANELCONFIG.DEPTH / 2,
            x: ((_b = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.position) === null || _b === void 0 ? void 0 : _b.x) - TOPPANELCONFIG.DEPTH / 2 + highFrameFirstSidePlateHoleDepth / 2,
            y: l1LastTopPanel.position.y,
            z: l1LastTopPanel.position.z + TOPPANELCONFIG.DEPTH / 2,
        };
        // const highSize = new MeshManage(renderLThis.highFrameMesh).getModelSize();
        const holeSize = {
            // width: highSize.x + TOPPANELCONFIG.DEPTH,
            width: ((_c = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _c === void 0 ? void 0 : _c.x) + TOPPANELCONFIG.DEPTH + highFrameFirstSidePlateHoleDepth,
            height: TOPPANELCONFIG.HEIGHT,
            depth: l1LastTopPanel.size.depth + TOPPANELCONFIG.DEPTH,
        };
        // modify by zhanyu.shen 20220104 end
        l1LastTopPanel.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
    }
    l1TopPanelArr.forEach((item) => {
        renderLThis.addMesh(item.mesh);
        renderLThis.topPanelMesh.push(item.mesh);
        renderLThis.topPanelObjs.push(item);
    });
}
// 渲染L2的台面
function renderL2TopPanelUtil(topPanelTexture, renderLThis) {
    var _a, _b, _c, _d;
    // L2边
    let lastFrame2 = (_a = renderLThis.templateJson.bottom.length2) === null || _a === void 0 ? void 0 : _a.frames[renderLThis.templateJson.bottom.length2.frames.length - 1];
    let mesh2;
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const l2SidePlateDepth = renderLThis.getSidePlateDepth('length2');
    // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜Z轴补板尺寸，如果补板在柜子中间，该值为0
    let sealPlateSizeZ = 0;
    // modify add by zhanyu.shen 20211227, 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如底柜160顶柜227)
    if (renderLThis.isSealPlateBeforeTopHightFrame(LengthType.Length2)
        || renderLThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length2)) {
        sealPlateSizeZ = renderLThis.getSealPlateSize(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
    }
    else {
        sealPlateSizeZ = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
    }
    if (lastFrame2) {
        mesh2 = renderLThis.scene.getMeshByName(lastFrame2.componentBasic.id);
    }
    else {
        lastFrame2 = (_b = renderLThis.templateJson.bottom.length1) === null || _b === void 0 ? void 0 : _b.frames[0];
        mesh2 = renderLThis.scene.getMeshByName(lastFrame2.componentBasic.id);
    }
    const lastMeshManage = new MeshManage(mesh2);
    const lengthZConfigs = lastMeshManage.getLengthZConfigs(sealPlateSizeZ + l2SidePlateDepth);
    const l2TopPanelArr = [];
    const l1TopPanelInfoArr = getLengthZTopPanelInfo(renderLThis, lengthZConfigs);
    l1TopPanelInfoArr.forEach((item) => {
        const tempTopPanel = new TopPanel(renderLThis.scene, item.position, item.size, true);
        tempTopPanel.createTopPanel(topPanelTexture);
        l2TopPanelArr.push(tempTopPanel);
    });
    const l2LastTopPanel = l2TopPanelArr[l2TopPanelArr.length - 1];
    const sinkPositionInfo = Object.assign({}, getFramePositionInfo(renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson, 'sink'));
    // 如果水槽在L2上面才整L2的台面
    if (sinkPositionInfo.id && sinkPositionInfo.location === 2) {
        // const tempLengthClass = new LengthZ(renderLThis.templateJson, renderLThis.scene);
        // eslint-disable-next-line max-len
        const { holePosition, holeSize } = renderLThis.bottomLength2.getSinkHolePosition(sinkPositionInfo.cabinetId, sinkPositionInfo.id, l2LastTopPanel.position.y, sinkPositionInfo.cornerCabinetDirection, sinkPositionInfo.frameInfo);
        renderLThis.bottomLength2.createHole(holePosition, holeSize, topPanelTexture, l2LastTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
    }
    // 如果有高柜，高柜位置挖洞
    if (renderLThis.highFrameMesh && renderLThis.highFrameMeshLocation === 2) {
        // version 2.0 modify by zhanyu.shen 20220104 begin 将多个高柜作为一个整体获取中心坐标和尺寸
        // const highFrameMeshBounds = renderLThis.highFrameMesh.getHierarchyBoundingVectors();
        // 2.3高柜新增一块侧板 台面挖洞需要相应调整
        // 侧板内侧的侧板厚度 2.3版本前无内侧侧板
        const highFrameFirstSidePlateHoleDepth = renderLThis.templateJson.version > '2.2' ? l2SidePlateDepth : 0;
        const highFrameData = renderLThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.bottom, LengthType.Length2); // new code
        const holePosition = { x: l2LastTopPanel.position.x, y: l2LastTopPanel.position.y, z: (_c = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.position) === null || _c === void 0 ? void 0 : _c.z };
        const holeSize = {
            width: l2LastTopPanel.size.width,
            height: TOPPANELCONFIG.HEIGHT,
            depth: ((_d = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _d === void 0 ? void 0 : _d.z) + l2SidePlateDepth + highFrameFirstSidePlateHoleDepth,
        };
        // modify by zhanyu.shen 20220104 end
        l2LastTopPanel.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
    }
    l2TopPanelArr.forEach((item) => {
        renderLThis.addMesh(item.mesh);
        renderLThis.topPanelMesh.push(item.mesh);
        renderLThis.topPanelObjs.push(item);
    });
}
/**
     * @description:渲染踢脚板
     * @param {*}
     * @return {*}
     * @author: Yongchao Wang
     */
function renderSkirtingBoardUtil(renderLThis) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const skirtingBoardTexture = (_d = (_c = (_b = (_a = renderLThis === null || renderLThis === void 0 ? void 0 : renderLThis.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.coverPlate) === null || _c === void 0 ? void 0 : _c.componentBasic) === null || _d === void 0 ? void 0 : _d.modelUrl;
    const lastFrame = (_e = renderLThis.templateJson.bottom.length1) === null || _e === void 0 ? void 0 : _e.frames[renderLThis.templateJson.bottom.length1.frames.length - 1];
    // const lastFrameDoor = lastFrame.doors[0];
    const mesh = renderLThis.scene.getMeshByName(lastFrame.componentBasic.id);
    if (!mesh) {
        return;
    }
    // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
    // add by zhanyu.shen 20211221 end
    // add by zhanyu.shen 20211228 begin
    let highFrameData = null;
    let highFrameFrontSideLength = 0; // 顶柜组里高柜的正面边长
    let sealPlateSizeX = 0; // 底柜和高柜间的补板长
    let highFrameSkirtingBoard = [];
    // 检查顶柜里是否有高柜 处理Length1边
    if (checkHasHightFrameByPosition(renderLThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
        highFrameData = renderLThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length1);
        highFrameFrontSideLength = (_f = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _f === void 0 ? void 0 : _f.x;
        if (renderLThis.isSealPlateBeforeTopHightFrame(LengthType.Length1, true)) {
            // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如底柜247顶柜317)
            // 原先的补板和空隙会合并为新尺寸补板，L1正面踢脚板长度延伸，右面位置移动到高柜右边
            sealPlateSizeX = renderLThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
        }
        else if (renderLThis.checkTopHightFrameIsSeparated(LengthType.Length1)) {
            // 底柜和顶柜高柜分离
            // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
            highFrameSkirtingBoard = renderLThis.renderTopHighFrameSkirtingBoardLength1(highFrameData, skirtingBoardTexture);
            highFrameFrontSideLength = 0; // 原先的踢脚板长度不需要延伸
            sealPlateSizeX = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
        }
        else {
            /** 此时底柜和高柜之间能连接在一起，如果L1边只有一个转角柜，有补板的话会放在高柜前面，sealPlateSizeX需要作为踢脚板延伸长度
               * （比如L1边底柜100顶柜139）
               *  L1边有多个柜子且有补板，补板的话会放在第一个柜子后面，sealPlateSizeX不需要作为踢脚板延伸长度
               * （比如L1边底柜107顶柜149）
              */
            sealPlateSizeX = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
        }
    }
    else {
        // 顶柜没有高柜，获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
        sealPlateSizeX = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    }
    // add by zhanyu.shen 20211228 end
    if (sealPlateSizeX === 0 && renderLThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
        // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
        sealPlateSizeX = renderLThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
    }
    const bounds = mesh.getHierarchyBoundingVectors();
    // const door = renderLThis.scene.getMeshByName(lastFrameDoor.componentBasic.id).getHierarchyBoundingVectors();
    const doorDepth = 0;
    // L1正面的踢脚板
    const position1 = {
        // version 2.0, modify by zhanyu.shen 20211228 把补板和顶部高柜宽度计入踢脚板X坐标
        // x: (bounds.min.x - FRAMEDEPTH.BOTTOM) / 2,
        x: (bounds.min.x - FRAMEDEPTH.BOTTOM) / 2 - sealPlateSizeX / 2 - highFrameFrontSideLength / 2,
        y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM - SKIRTINGBOARDCONFIG.DEPTH / 2 - doorDepth,
    };
    const size1 = {
        // version 2.0, modify by zhanyu.shen 20211221 把补板宽度计入踢脚板width
        // width: Math.abs(bounds.min.x) - FRAMEDEPTH.BOTTOM,
        width: Math.abs(bounds.min.x) - FRAMEDEPTH.BOTTOM + sealPlateSizeX + highFrameFrontSideLength,
        height: SKIRTINGBOARDCONFIG.HEIGHT,
        depth: SKIRTINGBOARDCONFIG.DEPTH,
    };
    const skirtingBoard1 = new SkirtingBoard(renderLThis.scene, position1, size1);
    skirtingBoard1.createSkirtingBoard(skirtingBoardTexture);
    renderLThis.skirtingBoard.push(skirtingBoard1);
    // L1右面的踢脚板
    const position2 = {
        // version 2.0, modify by zhanyu.shen 20211221 把补板和顶部高柜宽度计入踢脚板X坐标，L1右面只需移动位置尺寸不变
        // x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2,
        x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - sealPlateSizeX - highFrameFrontSideLength,
        y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM / 2,
    };
    const size2 = {
        width: SKIRTINGBOARDCONFIG.DEPTH,
        height: SKIRTINGBOARDCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM - doorDepth,
    };
    const skirtingBoard2 = new SkirtingBoard(renderLThis.scene, position2, size2);
    skirtingBoard2.createSkirtingBoard(skirtingBoardTexture);
    renderLThis.skirtingBoard.push(skirtingBoard2);
    let lastFrame2 = (_g = renderLThis.templateJson.bottom.length2) === null || _g === void 0 ? void 0 : _g.frames[renderLThis.templateJson.bottom.length2.frames.length - 1];
    lastFrame2 = lastFrame2 || ((_h = renderLThis.templateJson.bottom.length1) === null || _h === void 0 ? void 0 : _h.frames[0]);
    const mesh2 = renderLThis.scene.getMeshByName(lastFrame2.componentBasic.id);
    const bounds2 = mesh2.getHierarchyBoundingVectors();
    // version 2.0, add by zhanyu.shen 20211221 begin, 获取底柜Z轴补板尺寸，如果补板在柜子中间，该值为0
    // add by zhanyu.shen 20211221 end
    // add by zhanyu.shen 20211228 begin
    let highFrameData2 = null;
    let highFrameFrontSideLength2 = 0; // 顶柜组里高柜的正面边长
    let sealPlateSizeZ = 0; // 底柜和高柜间的补板长
    let highFrameSkirtingBoard2 = [];
    // 检查顶柜里是否有高柜 处理Length2边
    if (checkHasHightFrameByPosition(renderLThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length2)) {
        highFrameData2 = renderLThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length2);
        highFrameFrontSideLength2 = (_j = highFrameData2 === null || highFrameData2 === void 0 ? void 0 : highFrameData2.size) === null || _j === void 0 ? void 0 : _j.z;
        if (renderLThis.isSealPlateBeforeTopHightFrame(LengthType.Length2, true)) {
            // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如底柜160顶柜237)，L2正面踢脚板长度延伸，右面位置移动到高柜左边
            sealPlateSizeZ = renderLThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length2, AXES_ENUM.z);
        }
        else if (renderLThis.checkTopHightFrameIsSeparated(LengthType.Length2)) {
            // 底柜和顶柜高柜分离
            // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
            highFrameSkirtingBoard2 = renderLThis.renderTopHighFrameSkirtingBoardLength2(highFrameData2, skirtingBoardTexture);
            highFrameFrontSideLength2 = 0; // 原先的踢脚板长度不需要延伸
            sealPlateSizeZ = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
        }
        else {
            /** 此时底柜和高柜之间能连接在一起，如果L2边只有一个转角柜，有补板的话会放在高柜前面，sealPlateSizeZ需要作为踢脚板延伸长度
               * （比如L2边底柜78顶柜138）
               *  L1边有多个柜子且有补板，补板的话会放在第一个柜子后面，sealPlateSizeX不需要作为踢脚板延伸长度
               * （比如L2边底柜107顶柜149）
              */
            sealPlateSizeZ = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
        }
    }
    else {
        // 顶柜没有高柜，获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
        sealPlateSizeZ = renderLThis.getSealPlateSizeOnlyOneFrame(LengthLocation.Bottom, LengthType.Length2, AXES_ENUM.z);
    }
    // add by zhanyu.shen 20211228 end
    if (sealPlateSizeZ === 0 && renderLThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length2)) {
        // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
        sealPlateSizeZ = renderLThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length2, AXES_ENUM.z);
    }
    // L2正面的踢脚板
    const position3 = {
        x: SKIRTINGBOARDCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM,
        y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
        // version 2.0, modify by zhanyu.shen 20211221 把补板Z轴尺寸计入踢脚板Z坐标
        // z: (bounds2.max.z / 2 - bounds2.min.z / 2 + mesh2.position.z) / 2 + FRAMEDEPTH.BOTTOM / 2,
        z: (bounds2.max.z / 2 - bounds2.min.z / 2 + mesh2.position.z) / 2 + SKIRTINGBOARDCONFIG.DEPTH / 2
            + FRAMEDEPTH.BOTTOM / 2 + sealPlateSizeZ / 2 + highFrameFrontSideLength2 / 2,
    };
    const size3 = {
        width: SKIRTINGBOARDCONFIG.DEPTH,
        height: SKIRTINGBOARDCONFIG.HEIGHT,
        // version 2.0, modify by zhanyu.shen 20211221 把补板Z轴尺寸计入踢脚板深度
        // depth: (bounds2.max.z - bounds2.min.z) / 2 + mesh2.position.z - FRAMEDEPTH.BOTTOM,
        depth: (bounds2.max.z - bounds2.min.z) / 2 + SKIRTINGBOARDCONFIG.DEPTH
            + mesh2.position.z - FRAMEDEPTH.BOTTOM + sealPlateSizeZ + highFrameFrontSideLength2,
    };
    const skirtingBoard3 = new SkirtingBoard(renderLThis.scene, position3, size3);
    skirtingBoard3.createSkirtingBoard(skirtingBoardTexture);
    renderLThis.skirtingBoard.push(skirtingBoard3);
    let position4;
    let size4;
    if (renderLThis.templateJson.bottom.length2.frames.length !== 0) {
        // L2左面的踢脚板
        position4 = {
            x: -FRAMEDEPTH.BOTTOM / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            // version 2.0, modify by zhanyu.shen 20211228 把补板Z轴尺寸和高柜宽计入踢脚板Z坐标，L2左面只需移动位置尺寸不变，
            // z: bounds2.max.z - SKIRTINGBOARDCONFIG.DEPTH / 2,
            z: bounds2.max.z + SKIRTINGBOARDCONFIG.DEPTH / 2 + sealPlateSizeZ + highFrameFrontSideLength2,
        };
        size4 = {
            width: FRAMEDEPTH.BOTTOM,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: SKIRTINGBOARDCONFIG.DEPTH,
        };
    }
    else {
        // L2左面的踢脚板
        position4 = {
            x: -FRAMEDEPTH.BOTTOM / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            // version 2.0, modify by zhanyu.shen 20211228 把补板Z轴尺寸和高柜宽计入踢脚板Z坐标，L2左面只需移动位置尺寸不变，
            // z: bounds2.max.z - SKIRTINGBOARDCONFIG.DEPTH / 2,
            z: bounds2.max.z + SKIRTINGBOARDCONFIG.DEPTH / 2 + sealPlateSizeZ + highFrameFrontSideLength2,
        };
        size4 = {
            width: FRAMEDEPTH.BOTTOM,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: SKIRTINGBOARDCONFIG.DEPTH,
        };
    }
    const skirtingBoard4 = new SkirtingBoard(renderLThis.scene, position4, size4);
    skirtingBoard4.createSkirtingBoard(skirtingBoardTexture);
    renderLThis.skirtingBoard.push(skirtingBoard4);
    renderLThis.skirtingBoard.forEach((e) => {
        renderLThis.addMesh(e.mesh);
    });
    // renderLThis.skirtingBoardObjs = [skirtingBoard1, skirtingBoard2, skirtingBoard3, skirtingBoard4];
    // eslint-disable-next-line no-param-reassign
    renderLThis.skirtingBoardObjs = [skirtingBoard1, skirtingBoard2, skirtingBoard3, skirtingBoard4,
        ...highFrameSkirtingBoard, ...highFrameSkirtingBoard2];
}
export { renderL1TopPanelUtil, renderL2TopPanelUtil, renderSkirtingBoardUtil, };
